import { createSlice } from "@reduxjs/toolkit";
import { addratesDetailsAPI } from "../../api/chef";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const addratesDetailsSlice = createSlice({
  name: "addratesDetails",
  initialState: data,
  reducers: {
   addratesDetailsSlice(state) {
      state.isLoading = true;
    },
   addratesDetailsSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    addratesDetailsSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    addratesDetailsSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});

export const addratesDetailsHandler: any = (data:any) => async (dispatch: any) => {
  try {
    dispatch(addratesDetailsAction.addratesDetailsSlice());
    const response: any = await addratesDetailsAPI(data);
    
    dispatch(addratesDetailsAction.addratesDetailsSliceSuccess(response));
  } catch (e: any) {
    dispatch(addratesDetailsAction.addratesDetailsSliceFailure(e?.response?.data));
  }
};

export default addratesDetailsSlice.reducer;
export const addratesDetailsAction = addratesDetailsSlice.actions;